import { MenuListProps } from '../types';
import { ListContainer } from '../styled';
import { MenuItem } from './MenuItem';

import type { JSX } from 'react';

export const MenuList = ({
  columns,
  provider,
  className,
  checkboxVariant = 'secondary',
}: MenuListProps): JSX.Element | null => {
  if (!columns || !columns.length) {
    return null;
  }

  return (
    <ListContainer nItems={columns.length} className={className}>
      {columns.map((c) => (
        <MenuItem key={`${c.name}-${c.id}`} col={c} provider={provider} checkboxVariant={checkboxVariant} />
      ))}
    </ListContainer>
  );
};
